import type { RouteObject } from "react-router-dom";
import { useLocale } from "@admin/app/locale";
import { AppConfigsPage } from "./pages/AppConfigsPage";

function AppConfigsRoute() {
  const locale = useLocale();
  return <AppConfigsPage locale={locale} />;
}

export const appConfigRoutes: RouteObject[] = [
  {
    path: "app-configs",
    element: <AppConfigsRoute />,
  },
];
